import { gql } from "@apollo/client";

export const GET_PRESCRIPTION = gql`
  query getPrescriptions($id: String!) {
    getPrescriptions(id: $id) {
      items {
        id
        name
        dose
        indications
        issuedOn
        expiredOn
        quantity
        vetName
        vetDate
        state
        productUrl
      }
      success
      messages
    }
  }
`;
